export enum UserLockedReasons {
  LockedByAdmin = 'lockedByAdmin',
  KycRefused = 'kycRefused',
}

export enum LocalePathKey {
  LockedFromSingleCompany = 'lockedFromSingleCompany',
  LockedFromMultipleCompanies = 'lockedFromMultipleCompanies',
}
